import { CYAN, EXTRALARGE, LARGE, WHITE } from "shared/variables";
import { EventsListWrapper } from "components/EventsList";
import { getSingle, getDocs } from "shared/prismic";
import { Intro } from "components/Intro";
import { MaxWidth } from "components/MaxWidth";
import { Page } from "components/Page";
import { SpacingSection } from "components/SpacingSection";

export async function getStaticProps({ preview = null, previewData }) {
  const doc = await getSingle({ previewData, type: "agenda_overview" });
  const events = await getDocs({ previewData, type: "agenda_detail" });
  return { props: { doc, events, preview } };
}

const Index = ({ doc, events, preview }) => {
  const { seo_title, seo_description, seo_image, intro } = doc.data;

  return (
    <Page
      title={seo_title}
      description={seo_description}
      image={seo_image}
      color={CYAN}
      preview={preview}
    >
      <SpacingSection size={EXTRALARGE}>
        <SpacingSection size={LARGE}>
          <MaxWidth>
            <Intro color={WHITE} title="Agenda" text={intro} />
          </MaxWidth>
        </SpacingSection>
        <SpacingSection>
          <MaxWidth size={LARGE}>
            <EventsListWrapper events={events} />
          </MaxWidth>
        </SpacingSection>
      </SpacingSection>
    </Page>
  );
};

export default Index;
